export const appointmentsEn: Record<string, string> = {
  // Appointments (customer portal)
  'my_appointments': 'My Appointments',
  'view_appointment_photos': 'View your appointment photos and details',
  'upcoming': 'Upcoming',
  'past': 'Past',
  'no_past_appointments': 'No past appointments',
  'no_appointments_message': "You don't have any {filter} appointments at the moment.",
  'consultation': 'Consultation',
  'fitting': 'Fitting',
  'final_fitting': 'Final Fitting',
  'alteration': 'Alteration',
  'photos': 'Photos',
  'no_photos_yet': 'No photos yet',
  'photos_appear_here': "Photos from your appointment will appear here once they're uploaded by our team.",
  'photo_downloaded': 'Photo downloaded successfully',
  'photo_download_failed': 'Failed to download photo',
  'customer_information_not_available': 'Customer information not available',
  'failed_to_load_appointments': 'Failed to load appointments',
  'appointment_photo': 'Appointment Photo',
  'check_out_photo': 'Check out this photo from my appointment',
  'upcoming_appointments': 'Upcoming Appointments',
  'appointments.editAppointment': 'Edit Appointment',

  // Appointments page (admin)
  'appointments.title': 'Appointments',
  'appointments.subtitle': 'Manage customer appointments and consultations',
  'appointments.newAppointment': 'New Appointment',
  'appointments.errors.loadFailed': 'Failed to load appointments',
  'appointments.errors.fillRequired': 'Please fill in all required fields including fitting room',
  'appointments.success.deleted': 'Appointment deleted successfully',
  'appointments.success.created': 'Appointment created successfully',
  'appointments.success.updated': 'Appointment updated successfully',
  'appointments.errors.deleteFailed': 'Failed to delete appointment',
  'appointments.unknownCustomer': 'Unknown Customer',
  'appointments.form.title': 'Title *',
  'appointments.form.titlePlaceholder': 'e.g., Wedding Dress Consultation',
  'appointments.form.customer': 'Customer *',
  'appointments.form.selectCustomer': 'Select a customer',
  'appointments.form.type': 'Type *',
  'appointments.form.selectType': 'Select appointment type',
  'appointments.form.startTime': 'Start Time *',
  'appointments.form.endTime': 'End Time *',
  'appointments.form.roomLabel': 'Room',
  'appointments.form.selectRoom': 'Select fitting room',
  'appointments.form.assignedStaff': 'Assigned Staff',
  'appointments.form.selectStaff': 'Select staff member',
  'appointments.form.location': 'Location',
  'appointments.form.locationPlaceholder': 'e.g., Main Showroom, Private Suite',
  'appointments.form.description': 'Description',
  'appointments.form.descriptionPlaceholder': 'Additional notes about this appointment',
  'appointments.form.creating': 'Creating...',
  'appointments.form.updateButton': 'Update Appointment',
  'appointments.form.createButton': 'Create Appointment',
  'appointments.filter.room': 'Filter by Room',
  'appointments.filter.roomLabel': 'Filter by Room:',
  'appointments.filter.allRooms': 'All Rooms',
  'appointments.detailsTitle': 'Appointment Details',
  'appointments.tabs.details': 'Details',
  'appointments.tabs.photos': 'Photos',
  'appointments.detail.customer': 'Customer',
  'appointments.detail.staff': 'Staff',
  'appointments.detail.description': 'Description',
  'appointments.deleteConfirmation': 'Are you sure you want to delete this appointment?',
  'appointments.actions.delete': 'Delete Appointment',
  'appointments.actions.edit': 'Edit Appointment',

  // Appointment V2 / Calendar
  'calendar.view.agenda': 'Agenda',
  'calendar.view.day': 'Day',
  'calendar.view.week': 'Week',
  'calendar.view.month': 'Month',
  'calendar.action.new': 'New',
  'calendar.status.closed': 'Closed',
  'calendar.appointments.count': '{count} appointments',
  'calendar.appointments.single': '1 appointment',
  'calendar.legend.title': 'Legend',
  'calendar.no_upcoming': 'No upcoming appointments',
  'calendar.no_appointments_message': 'Create your first appointment to get started',
  'calendar.filter.room': 'Filter by room',
  'calendar.filter.staff': 'Filter by staff',
  'calendar.filter.type': 'Filter by type',
  'calendar.filter.all_rooms': 'All Rooms',
  'calendar.filter.all_staff': 'All Staff',
  'calendar.filter.all_types': 'All Types',
  'calendar.weekdays.mon': 'Mon',
  'calendar.weekdays.tue': 'Tue',
  'calendar.weekdays.wed': 'Wed',
  'calendar.weekdays.thu': 'Thu',
  'calendar.weekdays.fri': 'Fri',
  'calendar.weekdays.sat': 'Sat',
  'calendar.weekdays.sun': 'Sun',
  'calendar.appointments.more': '+{count} more',
  'calendar.today_label': ' (today)',
  'calendar.view_appointments_for': 'View appointments for {date}',
  'calendar.closed': 'Closed',
  'calendar.holiday': 'Holiday',
  'calendar.invalid_time': 'Invalid time',

  // Appointment types
  'appointment.consultation': 'Consultation',
  'appointment.fitting': 'Fitting',
  'appointment.final_fitting': 'Final Fitting',
  'appointment.alteration': 'Alteration',

  // Appointment form
  'appointment.edit': 'Edit Appointment',
  'appointment.new': 'New Appointment',
  'appointment.title': 'Title',
  'appointment.customer': 'Customer',
  'appointment.type': 'Type',
  'appointment.start_time': 'Start Time',
  'appointment.end_time': 'End Time',
  'appointment.fitting_room': 'Fitting Room',
  'appointment.staff': 'Staff',
  'appointment.location': 'Location',
  'appointment.description': 'Description',
  'appointment.additional_notes': 'Additional notes',
  'appointment.cancel': 'Cancel',
  'appointment.update': 'Update',
  'appointment.create': 'Create',
  'appointment.save': 'Save',
  'appointment.delete': 'Delete',
  'appointment.warning': 'warning',
  'appointment.can_save_with_warning': "The appointment can be saved with 1 warning",
  'appointment.fittings_note': 'Fittings typically last at least 1 hour',

  // Appointment validation
  'appointment.validation.duration_warning': 'Fittings typically last at least 1 hour',
  'appointment.validation.can_save_with_warning': "The appointment can be saved with 1 warning",
  'appointment.validation.warning': 'warning',
  'appointment.validation.required': 'This field is required',
  'appointment.validation.errors_summary': '{count} error(s) found',
  'appointment.validation.warnings_summary': '{count} warning(s)',
  'appointment.validation.info_summary': '{count} informational message(s)',
  'appointment.validation.details': 'Details',
  'appointment.validation.all_passed': 'All checks passed',

  // Form labels and placeholders
  'form.title_placeholder': 'Enter appointment title',
  'form.customer_placeholder': 'Select customer',
  'form.type_placeholder': 'Select type',
  'form.room_placeholder': 'Select fitting room',
  'form.staff_placeholder': 'Select staff member',
  'form.location_placeholder': 'Enter location',
  'form.description_placeholder': 'Enter additional notes...',
  'form.start_time_label': 'Start time',
  'form.end_time_label': 'End time',
  'form.no_customers': 'No customers available',
  'form.no_staff': 'No staff members available',
  'form.no_rooms': 'No fitting rooms available',

  // Toast messages
  'toast.appointment_created': 'Appointment created successfully',
  'toast.appointment_updated': 'Appointment updated successfully',
  'toast.appointment_deleted': 'Appointment deleted successfully',
  'toast.create_failed': 'Failed to create appointment',
  'toast.update_failed': 'Failed to update appointment',
  'toast.delete_failed': 'Failed to delete appointment',

  // Appointment form (AppointmentSheet V2)
  'appointment.form.customer': 'Customer',
  'appointment.form.type': 'Type',
  'appointment.form.startTime': 'Start Time',
  'appointment.form.endTime': 'End Time',
  'appointment.form.staff': 'Staff',
  'appointment.form.location': 'Location',
  'appointment.form.locationPlaceholder': 'Appointment location',
  'appointment.form.description': 'Description',
  'appointment.form.descriptionPlaceholder': 'Additional notes',
  'appointment.form.title': 'Title',
  'appointment.form.titlePlaceholder': 'Enter appointment title',
  'appointment.form.noCustomersFound': 'No customers found',

  // Appointment form additional
  'appointment.error.organizationNotFound': 'Organization not found',
  'appointment.error.requiredFields': 'Please fill in all required fields',
  'appointment.error.saveFailed': 'Failed to save appointment',
  'appointment.confirmation.proceedWithWarnings': 'Proceed with Warnings?',
  'appointment.confirmation.warningsDescription': 'This appointment has the following warnings:\n\n{warnings}\n\nDo you want to save it anyway?',
  'appointment.form.customerPlaceholder': 'Select customer',
  'appointment.form.searchCustomers': 'Search customers...',
  'appointment.form.noCustomer': 'No customer',
  'appointment.form.fittingRoom': 'Fitting Room',
  'appointment.form.fittingRoomPlaceholder': 'Select fitting room',
  'appointment.form.staffPlaceholder': 'Select staff member',
  'appointment.form.noStaffAssigned': 'No staff assigned',
  'appointment.form.validatingAppointment': 'Validating appointment...',
  'appointment.type.consultation': 'Consultation',
  'appointment.type.fitting': 'Fitting',
  'appointment.type.finalFitting': 'Final Fitting',
  'appointment.type.alteration': 'Alteration',
  'appointment.button.cancel': 'Cancel',
  'appointment.button.create': 'Create',
  'appointment.button.update': 'Update',
  'appointment.button.saving': 'Saving...',
  'appointment.button.saveAnyway': 'Save Anyway',
  'appointment.form.date': 'Date',
  'appointment.form.time': 'Time',

  // Appointment actions
  'appointment.actions.moreActions': 'More actions',
  'appointment.actions.editAppointment': 'Edit appointment',
  'appointment.actions.quickReschedule': 'Quick reschedule',
  'appointment.actions.duplicateTo': 'Duplicate to...',
  'appointment.actions.customDateTime': 'Custom date and time',
  'appointment.actions.deleteAppointment': 'Delete appointment',
  'appointment.actions.edit': 'Edit',
  'appointment.actions.delete': 'Delete',
  'appointment.actions.resyncGoogleCalendar': 'Resync with Google Calendar',

  // Quick reschedule
  'appointment.reschedule.tomorrow': 'Tomorrow',
  'appointment.reschedule.nextWeek': 'Next week',
  'appointment.reschedule.plusOneHour': '+1 hour',
  'appointment.reschedule.plusTwoHours': '+2 hours',
  'appointment.reschedule.nextMonth': 'Next month',

  // Toast messages
  'appointment.toast.rescheduled.title': 'Appointment rescheduled',
  'appointment.toast.rescheduled.description': 'Moved to {date}',
  'appointment.toast.reschedule.failed.title': 'Failed to reschedule',
  'appointment.toast.reschedule.failed.description': 'Please try again or reschedule manually',
  'appointment.toast.duplicated.title': 'Appointment duplicated',
  'appointment.toast.duplicated.description': 'Created copy for {date}',
  'appointment.toast.duplicate.failed.title': 'Failed to duplicate',
  'appointment.toast.duplicate.failed.description': 'Please try again',
  'appointment.toast.resync.success.title': 'Google Calendar Sync Successful',
  'appointment.toast.resync.success.description': 'Appointment has been successfully synced with Google Calendar',

  // Confirmation dialog
  'appointment.confirmation.confirm': 'Confirm',
  'appointment.confirmation.cancel': 'Cancel',
  'appointment.confirmation.pleaseWait': 'Please wait...',
  'appointment.aria.editForm': 'Edit appointment form',
  'appointment.aria.createForm': 'Create new appointment form',
  'appointment.aria.selectCustomer': 'Select customer for appointment',

  // Appointment Photos
  'appointments.photos.title': 'Photos',
  'appointments.photos.upload': 'Upload Photos',
  'appointments.photos.noPhotos': 'No photos yet',
  'appointments.photos.uploadForType': 'Upload photos for this {type} appointment',
  'appointments.photos.uploadFirst': 'Upload First Photo',
  'appointments.photos.selectPhotos': 'Select Photos',
  'appointments.photos.uploadLimit': 'You can upload up to {count} more photos',
  'appointments.photos.tagOptional': 'Tag (Optional)',
  'appointments.photos.selectTag': 'Select a tag for all photos',
  'appointments.photos.noTag': 'No tag',
  'appointments.photos.uploading': 'Uploading...',
  'appointments.photos.uploadCount': 'Upload {count} Photo(s)',
  'appointments.photos.uploadSuccess': '{count} photo(s) uploaded successfully',
  'appointments.photos.uploadError': 'Failed to upload photo',
  'appointments.photos.loadError': 'Failed to load photos',
  'appointments.photos.deleteConfirm': 'Are you sure you want to delete this photo?',
  'appointments.photos.deleteSuccess': 'Photo deleted successfully',
  'appointments.photos.deleteError': 'Failed to delete photo',
  'appointments.photos.sharedWithBride': 'Photo shared with bride',
  'appointments.photos.hiddenFromBride': 'Photo hidden from bride',
  'appointments.photos.visibilityError': 'Failed to update photo visibility',
  'appointments.photos.tagSuccess': 'Photo tag updated',
  'appointments.photos.tagError': 'Failed to update photo tag',
  'appointments.photos.visible': 'Visible',
  'appointments.photos.hidden': 'Hidden',
  'appointments.photos.hideFromBride': 'Hide from bride',
  'appointments.photos.shareWithBride': 'Share with bride',
  'appointments.photos.deletePhoto': 'Delete photo',
  'appointments.photos.tag.front': 'Front View',
  'appointments.photos.tag.back': 'Back View',
  'appointments.photos.tag.side': 'Side View',
  'appointments.photos.tag.detail': 'Detail',
  'appointments.photos.tag.fitting': 'Fitting Progress',
  'appointments.photos.tag.alteration': 'Alteration',
  'appointments.photos.download': 'Download',
  'appointments.photos.editPhoto': 'Edit Photo',
  'appointments.photos.removeBackground': 'Remove Background',

  // Bulk photo actions
  'appointments.photos.bulk.selectAll': 'Select All',
  'appointments.photos.bulk.selected': '{count} selected',
  'appointments.photos.bulk.addTag': 'Add tag',
  'appointments.photos.bulk.removeTag': 'Remove tag',
  'appointments.photos.bulk.show': 'Show',
  'appointments.photos.bulk.hide': 'Hide',
  'appointments.photos.bulk.download': 'Download',
  'appointments.photos.bulk.delete': 'Delete',
  'appointments.photos.bulk.deleteTitle': 'Delete Selected Photos',
  'appointments.photos.bulk.deleteDescription': 'Are you sure you want to delete {count} selected photo(s)? This action cannot be undone.',
  'appointments.photos.bulk.cancel': 'Cancel',
  'appointments.photos.bulk.deleteConfirm': 'Delete Photos',

  // Drag & drop upload
  'appointments.photos.dragDrop.dropHere': 'Drop files here',
  'appointments.photos.dragDrop.dragAndDrop': 'Drag & drop images here',
  'appointments.photos.dragDrop.or': 'or',
  'appointments.photos.dragDrop.browseFiles': 'browse files',
  'appointments.photos.dragDrop.supports': 'Supports: JPG, PNG, GIF, WebP',
  'appointments.photos.dragDrop.maxSize': 'Max size: 10MB per file',
  'appointments.photos.dragDrop.upToFiles': 'Up to {count} files',
  'appointments.photos.dragDrop.tagOptional': 'Tag (optional):',
  'appointments.photos.dragDrop.selectTag': 'Select a tag',
  'appointments.photos.dragDrop.selectedFiles': 'Selected Files ({count})',
  'appointments.photos.dragDrop.clearAll': 'Clear All',
  'appointments.photos.dragDrop.uploadingFiles': 'Uploading files...',
  'appointments.photos.dragDrop.uploadFiles': 'Upload {count} File(s)',

  // Photo lightbox
  'appointments.photos.lightbox.untitled': 'Untitled',
  'appointments.photos.lightbox.ofTotal': '{current} of {total}',
  'appointments.photos.lightbox.reset': 'Reset',

  // Background removal
  'appointments.photos.bgRemoval.title': 'Background Removal',
  'appointments.photos.bgRemoval.original': 'Original',
  'appointments.photos.bgRemoval.removed': 'Background Removed',
  'appointments.photos.bgRemoval.processing': 'Processing...',
  'appointments.photos.bgRemoval.clickToProcess': 'Click "Remove Background" to process',
  'appointments.photos.bgRemoval.processingImage': 'Processing image...',
  'appointments.photos.bgRemoval.removeButton': 'Remove Background',
  'appointments.photos.bgRemoval.download': 'Download',
  'appointments.photos.bgRemoval.saveToAppointment': 'Save to Appointment',
  'appointments.photos.bgRemoval.loadingModel': 'Loading AI model...',
  'appointments.photos.bgRemoval.loadingModelDesc': 'This may take a moment on first use',
  'appointments.photos.bgRemoval.success': 'Background removed successfully',
  'appointments.photos.bgRemoval.error': 'Failed to remove background',

  // Photo comparison
  'appointments.photos.comparison.title': 'Photo Comparison',
  'appointments.photos.comparison.before': 'Before',
  'appointments.photos.comparison.after': 'After',
  'appointments.photos.comparison.swap': 'Swap',
  'appointments.photos.comparison.selectTwo': 'Select two photos to compare',
  'appointments.photos.comparison.untitled': 'Untitled',

  // Actions menu header
  'appointment.actions.actionsFor': 'Actions for {title}',
  'appointment.toast.resync.failed.title': 'Sync Failed',
  'appointment.toast.resync.failed.description': 'Failed to sync with Google Calendar. Please try again.',

  // Create Appointment Dialog
  'appointments.create.title': 'Create New Appointment',
  'appointments.create.businessHoursWarning': 'Business hours have not been configured. Please contact an administrator to set up business hours before creating appointments.',
  'appointments.create.validating': 'Validating...',
  'appointments.create.validation.noBusinessHours': 'Business hours have not been configured. Please contact an administrator.',
  'appointments.create.validation.outsideHours': 'Appointment time is outside business hours.',
  'appointments.create.validation.holiday': 'Business is closed on the selected date.',
  'appointments.create.validation.lunchBreak': 'Appointment conflicts with a scheduled lunch break.',
  'appointments.create.validation.invalid': 'Invalid appointment time selected.',
  'appointments.create.validation.cannotValidate': 'Unable to validate appointment time',
  'appointments.create.validation.noBusinessHoursDay': 'Business hours are not configured for this day',
  'appointments.create.validation.outsideHoursShort': 'Appointment time is outside business hours',
  'appointments.create.validation.holidayShort': 'Cannot book appointments on holidays',
  'appointments.create.validation.lunchBreakShort': 'Appointment conflicts with a lunch break',
  'appointments.create.failedToCreate': 'Failed to create appointment',

  // Appointment Detail Dialog
  'appointments.detail.close': 'Close',
  'appointments.detail.measurement': 'Measurement',
  'appointments.detail.delivery': 'Delivery',
  'appointments.detail.loading': 'Loading Appointment...',
  'appointments.detail.noSelection': 'No appointment selected',
  'appointments.detail.syncError': 'Sync Error',
  'appointments.detail.syncSynced': 'Synced',
  'appointments.detail.syncPending': 'Syncing',
  'appointments.detail.syncFailed': 'Sync Failed',
  'appointments.detail.syncTooltipSynced': 'Successfully synced with Google Calendar',
  'appointments.detail.syncTooltipPending': 'Sync with Google Calendar in progress',
  'appointments.detail.syncTooltipFailed': 'Failed to sync with Google Calendar',
  'appointments.detail.syncLastSynced': 'Last synced: {date}',
  'appointments.detail.tip': 'Tip: Click appointments to view, use actions menu to edit',
  'appointments.detail.deleteTitle': 'Delete Appointment',
  'appointments.detail.deleteConfirm': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
  'appointments.detail.appointment': 'Appointment',
  'calendar.filter.filters': 'Filters',
  'calendar.no_appointments_today': 'No appointments for today',
  'calendar.aria.navigation': 'Calendar navigation',
  'calendar.aria.filters': 'Appointment filters',
  'calendar.aria.filterByRoom': 'Filter by room',
  'calendar.aria.filterByStaff': 'Filter by staff member',
  'calendar.aria.filterByType': 'Filter by appointment type',
  'calendar.aria.viewOptions': 'Calendar view options',
  'calendar.action.previous': 'Previous',
  'calendar.action.next': 'Next',
  'calendar.action.goToToday': 'Go to today',
  'calendar.period.day': 'day',
  'calendar.period.week': 'week',
  'calendar.period.month': 'month',

  // Appointment card
  'appointment.card.aria.viewDetails': 'View appointment details: {title} on {date}',
  'appointment.card.title.viewDetails': 'Click to view appointment details',
  'appointment.card.aria.type': 'Appointment type: {type}',
  'appointment.card.typeLabel': 'Type: {type}',
  'appointment.card.aria.googleSync': 'Google Calendar sync status: {status}',
  'appointment.card.sync.notSynced': 'not synced',
  'appointment.card.googleCalendar': 'Google Calendar',
  'appointment.card.syncIssue': 'Sync issue',
  'appointment.card.googleSyncError': 'Google Calendar sync error:',

  // Batch operations
  'appointments.batch.title': 'Batch Operations',
  'appointments.batch.selectOperation': 'Select Operation',
  'appointments.batch.targetDate': 'Target Date',
  'appointments.batch.selectAppointments': 'Select Appointments ({selected}/{total})',
  'appointments.batch.selectAll': 'Select All',
  'appointments.batch.error.selectTargetDate': 'Please select a target date',
  'appointments.batch.action.move': 'Move',
  'appointments.batch.action.duplicate': 'Duplicate',
  'appointments.batch.operation.select': 'Select Operation',
  'appointments.batch.operation.deleteLabel': 'Delete Selected Appointments',
  'appointments.batch.operation.moveLabel': 'Move Selected Appointments',
  'appointments.batch.operation.duplicateLabel': 'Duplicate Selected Appointments',
  'appointments.batch.operation.deleteDescription': 'This will permanently delete {count} appointment(s). This action cannot be undone.',
  'appointments.batch.operation.moveDescription': 'This will move {count} appointment(s) to the selected date, preserving the original time.',
  'appointments.batch.operation.duplicateDescription': 'This will create copies of {count} appointment(s) on the selected date.',
  'appointments.batch.operation.chooseDescription': 'Choose an operation to perform on the selected appointments.',
};
